export class EncriptDecript {
  encrypt(value: any): any {
    return btoa(encodeURIComponent(value));
  }

  decrypt(value: any): any {
    return decodeURIComponent(atob(value));
  }
}
